export const settlementStatus = {
  scheduled: 'SCHEDULED',
  settled: 'SETTLED',
  inProgress: 'IN PROGRESS',
  failed: 'FAILED',
}
export const PAYMENTGRACEPERIODDAYS = 5
